import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'markdownBold',
})
export class MarkdownBoldPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string): SafeHtml {
        if (!value) {
            return '';
        }
        // Replace asterisks with <strong> tags
        const replacedValue = value.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
        // Sanitize the HTML to avoid XSS attacks
        return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
    }
}
